import { Performance, Rink, Markings } from "./schema";

const BASE = import.meta.env.BASE_URL;

// When packaged as a single self-contained HTML, all data is embedded on
// window.__CHOREO__ so the app needs no server / fetch.
interface Embedded {
  manifest: Manifest;
  rink: unknown;
  markings: unknown;
  performances: Record<string, unknown>; // keyed by manifest entry.path
  music: Record<string, string>; // entry.path -> data URL
}
function embedded(): Embedded | null {
  return (typeof window !== "undefined" && (window as unknown as { __CHOREO__?: Embedded }).__CHOREO__) || null;
}

async function getJson(path: string): Promise<unknown> {
  const res = await fetch(BASE + path);
  if (!res.ok) throw new Error(`Failed to fetch ${path}: ${res.status}`);
  return res.json();
}

export interface Manifest {
  performances: { id: string; title: string; path: string }[];
}

export async function loadManifest(): Promise<Manifest> {
  const e = embedded();
  return e ? e.manifest : ((await getJson("performances/index.json")) as Manifest);
}

export async function loadRink(): Promise<Rink> {
  const e = embedded();
  return Rink.parse(e ? e.rink : await getJson("rink.json"));
}

export async function loadMarkings(): Promise<Markings> {
  const e = embedded();
  return Markings.parse(e ? e.markings : await getJson("markings.json"));
}

export async function loadPerformance(path: string): Promise<Performance> {
  const e = embedded();
  const raw = e ? e.performances[path] : await getJson(path);
  const parsed = Performance.safeParse(raw);
  if (!parsed.success) {
    console.error("Performance validation failed:", parsed.error.format());
    throw new Error("Invalid performance dataset — see console for details.");
  }
  return parsed.data;
}

export function musicUrlFor(entryPath: string, perf: Performance): string {
  const e = embedded();
  if (e && e.music[entryPath]) return e.music[entryPath];
  return BASE + entryPath.replace(/[^/]+$/, "") + perf.music.src;
}
